import React from "react";
import { Input, InputGroup, InputGroupText } from "reactstrap";
import { RiSearchLine } from "react-icons/ri";

/**
 * Reusable Table Search Component
 * @param {string} value - Current search value
 * @param {function} onChange - Callback function when search value changes
 * @param {string} placeholder - Placeholder text for search input
 * @param {string} className - Additional CSS classes
 */
const TableSearch = ({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
}) => {
  return (
    <InputGroup >
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />{" "}
      <InputGroupText style={{ cursor: "pointer" }}>
        <i className="bx bx-search"></i>
      </InputGroupText>
    </InputGroup>
  );
};

export default TableSearch;
